var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "crud-table",
        {
          ref: "table",
          attrs: {
            api: "portal_todo_templates",
            label: "Portal-Aufgaben",
            name: { singular: "Portal-Aufgabe", plural: "Portal-Aufgaben" },
            filter: _vm.params,
            columns: _vm.columns,
          },
          on: {
            add: _vm.openForm,
            edit: _vm.openForm,
            dataLoaded: (data) =>
              _vm.$store.commit("updateData", { portalTodoTemplates: data }),
          },
          scopedSlots: _vm._u([
            {
              key: "dueDateMode",
              fn: function (slotProps) {
                return [
                  _vm._v(
                    "\n            " +
                      _vm._s(_vm.dueLabel(slotProps.row)) +
                      "\n        "
                  ),
                ]
              },
            },
            {
              key: "autoAssignToCreator",
              fn: function (slotProps) {
                return [
                  _vm._v(
                    "\n            " +
                      _vm._s(
                        slotProps.row.autoAssignToCreator
                          ? "Ersteller"
                          : "niemand"
                      ) +
                      "\n        "
                  ),
                ]
              },
            },
            {
              key: "active",
              fn: function (slotProps) {
                return [
                  slotProps.row.active
                    ? _c("i", { staticClass: "material-icons" }, [
                        _vm._v("check"),
                      ])
                    : _vm._e(),
                ]
              },
            },
            {
              key: "footer",
              fn: function () {
                return [
                  _c("div", { staticClass: "level level-left" }, [
                    _c(
                      "a",
                      {
                        staticClass: "button level-item is-primary",
                        on: { click: _vm.openForm },
                      },
                      [_vm._v("Aufgabe hinzufügen")]
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("h2", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("Vordefinierte Aufgaben"),
          ]),
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _vm._v(" "),
          _c("todo-template-form", {
            ref: "form",
            attrs: { slot: "form", formType: "modal" },
            on: {
              success: function ($event) {
                return _vm.$refs.table.refresh()
              },
            },
            slot: "form",
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }